import { render, staticRenderFns } from "./Messager.vue?vue&type=template&id=a6ba0904&"
import script from "./Messager.vue?vue&type=script&lang=js&"
export * from "./Messager.vue?vue&type=script&lang=js&"
import style0 from "./Messager.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports